import { render } from "./AdaptiveQABody.vue?vue&type=template&id=ba1f7784&scoped=true"
import script from "./AdaptiveQABody.vue?vue&type=script&lang=js"
export * from "./AdaptiveQABody.vue?vue&type=script&lang=js"

import "./AdaptiveQABody.vue?vue&type=style&index=0&id=ba1f7784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1f7784"]])

export default __exports__